import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './NavigationBar.css';

function NavigationBar() {
    const { i18n } = useTranslation();
    const lang = i18n.language?.slice(0, 2) || 'en';
    const changeLang = (l) => i18n.changeLanguage(l);

    return (
        <div className="navbar">
          <div className="navbar-lockup">
            <Link to="/feed" className="navbar-logo">
              <svg viewBox="0 0 1004.85 500">
                <path d="M262.89,461.45a228.07,228.07,0,0,0,81-15.29,13.84,13.84,0,0,1,4.86-1.12c2.74,0,4.78,1.5,6.38,5.18l8.93,20.58a10,10,0,0,1,1,3.93c0,2.81-1.79,5.1-6.08,6.79A263.65,263.65,0,0,1,263.48,500,262.08,262.08,0,0,1,150.28,1.36,11.93,11.93,0,0,1,155.33,0c2.91,0,4.85,1.8,6.2,4.9L170,24.33a15.8,15.8,0,0,1,1.67,5.9c0,2.62-1.65,4.42-5.73,6.38C88.8,73.75,40,149.55,40,238c0,59.69,22.68,115.8,64.89,158A222,222,0,0,0,262.89,461.45Z" transform="translate(-1)"/>
                <path d="M331.15,396.85c0,2.88-1.91,4.93-6.35,6.6a175.26,175.26,0,0,1-61.9,11.17C165.51,414.62,86,335.39,86,238S165.51,61.37,262.9,61.37a175.13,175.13,0,0,1,63.4,11.74c2.85,1.09,4.74,3.07,4.74,6.15A11.45,11.45,0,0,1,330,83.78l-8.86,20.34c-1.51,3.47-3.3,5.16-6.19,5.16a13.38,13.38,0,0,1-4.55-1c-15-5.56-28.8-8.37-47.45-8.37-76.13,0-137.9,62-137.9,138.08s61.77,138.07,137.9,138.07A137,137,0,0,0,309.5,368a16.22,16.22,0,0,1,5.29-1.18c2.77,0,4.75,1.5,6.47,5.45l8.73,20A11.68,11.68,0,0,1,331.15,396.85Z" transform="translate(-1)"/>
                <path d="M356.52,233.46c0-.21,0-.42,0-.63-2.34-30.58-17.57-56.94-42.72-73a92.08,92.08,0,0,0-50.14-14.7,87.74,87.74,0,0,0-30,5c-3.76,1.47-5.66,3.74-5.66,6.55a8.1,8.1,0,0,0,.79,3.32l10,22.58a5.77,5.77,0,0,0,5.76,3.88,15.37,15.37,0,0,0,4.12-.67,54.36,54.36,0,0,1,44.3,6.56c14,9,22.87,23.58,25,40.8.41,3.35,1.82,7.05,7.47,7.05h23.84C353.73,240.12,356.52,237.32,356.52,233.46Z" transform="translate(-1)"/>
                <path d="M476,185h.67c7.05-8.29,23.18-21.57,51.06-21.57,21.83,0,39,7.63,48.7,24.56,8.4-9.63,27.21-24.56,57.78-24.56,36.61,0,59.79,19.58,59.79,66V330H658V236.14c0-30-12.45-41.94-35-41.94-17.83,0-30.62,9-38.35,17a98.61,98.61,0,0,1,1.34,18V330H550V236.14c0-30-12.45-41.94-34.66-41.94-18.16,0-30.61,10.65-37.34,18.31V330H442V167h34Z" transform="translate(-1)"/>
                <path d="M797.22,233.68c-31.13-10-37.49-15.31-37.49-25.63,0-9.32,9-15,26.45-15,20.72,0,34.58,8.51,43,13.51l12-27.49c-8.7-5.66-25.11-15.64-55.58-15.64-35.82,0-59.92,17-59.92,45.93,0,28.62,18.41,40.27,48.54,50.59,30.13,10,35.83,16,35.83,26.3s-8.37,17.63-28.13,17.63c-24.05,0-39.12-10.66-46.51-17l-12.74,29.31c8.36,6.66,25.77,18.31,60.26,18.31,40.84,0,62.6-20.31,62.6-50.93C845.43,257,827.69,243.33,797.22,233.68Z" transform="translate(-1)"/>
                <path d="M994,292c-6.05,4-18.42,10.61-39.44,10.61-29.8,0-49.55-16.64-49.55-54.92,0-36.94,24.1-52.92,52.89-52.92,18.36,0,28.4,6.28,35.42,10.94l12.07-27.76c-9.36-6.56-23.11-14.46-51.17-14.46-43.52,0-86,26.62-86,85.87s33.14,85.21,81,85.21c32,0,48.86-10.12,56.68-15.24Z" transform="translate(-1)"/>
              </svg>
            </Link>
            <div className="navbar-divider"></div>
            <div className="navbar-lockup-text">
              <span className="navbar-takes">by Takes</span>
              <span className="navbar-demo">Demo</span>
            </div>
          </div>

          <div className="navbar-right">
            <div className="navbar-live">
              <span className="navbar-live-dot"></span>
              Live
            </div>
            <div className="nb-lang">
              {['en', 'de', 'fr'].map(l => (
                <button
                  key={l}
                  className={`nb-lang-btn${lang === l ? ' active' : ''}`}
                  onClick={() => changeLang(l)}
                >
                  {l.toUpperCase()}
                </button>
              ))}
            </div>
            <Link to="/profile" className="navbar-profile-btn" aria-label="Edit profile">
              <svg viewBox="0 0 24 24"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
            </Link>
          </div>

          <hr className="navbar-separator" />
        </div>
      );
  }

  export default NavigationBar;